<template>
<div>
    <div class="level">
        <div class="level-left">
            <div class="level-item">
                <span class="title is-3">
                    <i class="fas fa-user-cog"></i>
                </span>
                &ensp;&ensp;<div class="title">Users</div>
            </div>
        </div>
        <!-- <div class="level-right">
            <div class="level-item">
                <a class="button is-warning full-width-button" style=" width: 300px;  " @click="openModal()">
                     <span class="icon is-small">
                            <i class="fas fa-plus"></i>
                        </span>
                    <span>Add New User</span>
                </a>
            </div>
        </div> -->
    </div>
    <div class="column is-4" v-if="!users">

        <p class="title" v-if="isUsersLoading">Loading users...</p>
        <!-- <p v-if="!isUsersLoading && !users">Please select a category to view its users.</p> -->
    </div>

    <div class="column   users-container" v-if="users">

        <!--         <div class="columns is-multiline"> -->
        <p class="title" v-if="isUsersLoading">Loading users...</p>
        <!-- <div v-if="users.length"> -->
        <b-tabs position="is-centered" class="block" >
            <b-tab-item label="Candidates">
                <table class="table is-fullwidth is-responsive" :data="user">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>status</th>
                            <th>Premium</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in fns" :key="user.docId">
                            <td>{{index + 1}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.email}}</td>
                            <td>{{user.mobile}}</td>
                            <td>
                                <b-tag type="is-success" v-if="user.active == true" rounded>Active</b-tag>
                                <b-tag type="is-danger" v-else rounded>Inactive</b-tag>
                            </td>
                            <td>
                                <img width="23" v-if="user.premium == true" src="/static/crown.gif" alt="" srcset="">
                               
                            </td>

                            <td>
                    <i class="fas fa-edit icon" @click="openModal(user)" title="Edit user"></i>
                <i class="fa fa-trash icon" @click="deleteUser(user)" title="Delete user"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-tab-item>
            <b-tab-item label="Admin">
                <table class="table is-fullwidth is-responsive" :data="dms">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>

                            <th>Last Login</th>
                            <th>status</th>

                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user, index) in dms" :key="user.docId">
                            <td>{{index + 1}}</td>
                            <td>{{user.name}}</td>
                            <td>{{user.email}}</td>

                            <td>{{time(user.loggedInAt)}}</td>
                            <td>
                                <b-tag type="is-success" v-if="user.active == true" rounded>Active</b-tag>
                                <b-tag type="is-danger" v-else rounded>Inactive</b-tag>
                            </td>

                            <td>

                                <i class="fas fa-edit icon" @click="openModal(user)" title="Edit user"></i>
                                <i class="fa fa-trash icon" @click="deleteUser(user)" title="Delete user"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-tab-item>

        </b-tabs>

        <!--  </div> -->
        <!-- </div> -->

    </div>
</div>
</template>

<script>
import AddUser from './AddUser';
import UsersService from './service';

import UploadService from '../../lib/UploadService';

import moment from 'moment';
export default {
    name: 'users',
    created() {

        this.fetchDm();

        this.fetchFn();

        this.$on('QURY_UPDATE', (updatedUser, isNewUser) => {
            if (isNewUser) {
                this.users.unshift(updatedUser);
            } else {
                this.users = this.users.map(user => {
                    if (user.docId === updatedUser.docId) {
                        return updatedUser;
                    }
                    return user;
                });
            }
        });
    },
    components: {
        AddUser
    },
    data() {
        const data = [this.users]
        return {
            isUsersLoading: false,
            searchName: null,
            isAddUpdateUserModalOpen: false,
            files: null,
            isLoading: true,
            users: [],
            dms: [],
            fns: [],

            status,
            isBordered: true,
            isStriped: true,
            isNarrowed: false,
            isHoverable: true,
            isFocusable: false,
            hasMobileCards: true,
            isPaginated: true,
            isPaginationSimple: false,
            defaultSortDirection: 'asc',
            currentPage: 1,
            perPage: 5,
            user: null
        };
    },
    methods: {
        time(timeStamp) {
            return moment(timeStamp).format('MMMM Do YYYY, h:mm:ss a');
        },
        time1(timeStamp) {
            return moment(timeStamp).format('LT');
        },
        /* fetchUsers() {
            this.isUsersLoading = true;
            this.users = null;
            UsersService.all().then(users => {
                this.users = users;
                this.isUsersLoading = false;
            });
        }, */
        fetchDm() {
            this.isUsersLoading = true;
            this.dms = null;
            UsersService.dm().then(dm => {
                this.dms = dm;
                this.isUsersLoading = false;
            });
        },

        fetchFn() {
            this.isUsersLoading = true;
            this.fns = null;
            UsersService.fn().then(fn => {
                this.fns = fn;
                this.isUsersLoading = false;
            });
        },
        deleteUser(userToDelete) {
            this.isUsersLoading = true;
            this.$buefy.dialog.confirm({
                message: 'Sure to delete user?',
                onConfirm: () => {
                    UsersService.deleteUser(userToDelete.docId).then(() => {
                        this.users = this.users.filter(
                            user => userToDelete.docId !== user.docId
                        );
                        this.isUsersLoading = false;
                        this.$buefy.toast.open('User deleted successfully');
                    });
                }
            });
        },
        openModal(user = null) {
            this.$buefy.modal.open({
                parent: this,
                props: {
                    propUser: user,
                },
                component: AddUser,
                hasModalCard: true
            });
        },
        openLocation(user = null) {
            this.$buefy.modal.open({
                parent: this,
                props: {
                    propUser: user,
                },
                component: location,
                hasModalCard: true
            });
        },
        uploadImage(user) {
            UploadService(this.files[0], 'users', user.docId)
                .then(() => {
                    this.isLoading = false;
                    this.$toast.open('Image saved successfully');
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$toast.open('Error saving image');
                });
        }
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/users/Users.vue